// ✅ FULL TAILWIND VERSION (Fixed Upload + Update)

import React, { Component } from "react";
import { connect } from "react-redux";
import { dashboardActions, surveyActions } from "../../../_actions";
import { SheetJSFT } from "./types";
import * as XLSX from "xlsx";
import UploadPreview from "./Modal/UploadPreview";
import moment from "moment";
import LayoutWrap from "../Component/LayoutWrap";
import Table from "../Component/Table";
import { FaPlus } from "react-icons/fa";
import { LuDownload, LuPlus, LuCheck, LuUsers, LuUpload, LuSearch, LuChevronLeft, LuChevronRight, } from 'react-icons/lu';
import { HiChevronLeft } from 'react-icons/hi';
import DeleteEmpModal from "./Modal/DeleteEmpModal";
import { MdOutlineClose } from 'react-icons/md'
import { BsCheckCircle } from "react-icons/bs";


class Employees extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fileUploadError: "",
      searchEmployee: "",
      showEmployeeModal: false,
      employeesize2: 10,
      currentSurveyPage: 1,
      employeeData: "",
      loadedDataSheet: [],
      showUploadPreview: false,
      pageNo: 1,
      size: 100,
      keyWord: "",
      formData: {
        "name": "",
        "emp_id": "",
        "email": "",
        "role": ""
      },
      updateFormData: {
        "id": "",
        "name": "",
        "emp_id": "",
        "email": "",
        "role": ""
      },
      updateEmployeeDetails: false,
      activeTab: 1,
      showDeleteConfirm: false
    };
  }



  componentDidMount() {
    let data = { keyWord: "", pageNo: 1, size: 100 }
    this.props.dispatch(dashboardActions.getInsightEmployeeList(data));
  }

  // ✅ FIXED FILE UPLOAD
  handleChange = (e) => {
    const file = e.target.files?.[0];

    if (!file) {
      this.setState({ fileUploadError: "No file selected!" });
      return;
    }

    const fileName = file.name.toLowerCase();
    const isValid = fileName.endsWith(".csv") || fileName.endsWith(".xlsx");

    if (!isValid) {
      this.setState({ fileUploadError: "Please upload csv or xlsx file!" });
      return;
    }

    this.setState({
      file,
      fileUploadError: "",
      loadedDataSheet: [],
      showUploadPreview: true,
    });

    const reader = new FileReader();
    const rABS = !!reader.readAsBinaryString;

    if (rABS) reader.readAsBinaryString(file);
    else reader.readAsArrayBuffer(file);

    reader.onload = (event) => {
      const bstr = event.target.result;
      const wb = XLSX.read(bstr, {
        type: rABS ? "binary" : "array",
      });

      const wsname = wb.SheetNames[0];
      const ws = wb.Sheets[wsname];

      let data = XLSX.utils.sheet_to_json(ws);

      data = data.map((row) => {
        let newRow = { ...row };
        Object.keys(newRow).forEach((key) => {
          const val = newRow[key];
          if (moment(val, ["MM/DD/YYYY", "MM/DD/YY"], true).isValid()) {
            newRow[key] = moment(val).format("DD-MM-YYYY");
          }
        });
        return newRow;
      });

      this.setState({
        loadedDataSheet: data,
        showEmployeeModal: false,
      });
    };
  };

  // ✅ UPDATE FUNCTION
  handleUpdateEmployeeSubmit = () => {
    const { employeeData } = this.state;

    const payload = {
      id: employeeData.id,
      email: employeeData.email,
      mobile: employeeData.mobile,
      emp_id: employeeData.emp_id,
      role: employeeData.role,
      isTest: employeeData.isTest,
    };

    const refreshPayload = {
      keyWord: "",
      pageNo: 1,
      size: this.state.employeesize2,
    };

    this.props.dispatch(
      dashboardActions.updateInsightEmployee(payload, refreshPayload)
    );
  };

  handleEmployeeDetails = (emp) => {
    this.setState({ employeeData: emp });
  };

  saveUploadEmployee = () => {
    const { loadedDataSheet } = this.state;

    if (loadedDataSheet.length > 0) {

      let temp = { keyWord: "", pageNo: 1, size: 1000 }

      this.props.dispatch(
        dashboardActions.saveInsightEmployeeList(loadedDataSheet, temp)
      );
    }
  };


  downLoadSampleCSV = () => {
    let binary_univers = [
      {
        emp_id: "001",
        email: "sample@mail.com",
        name: "Employee001"
      },
    ];

    console.log("binary_univers: ", binary_univers);

    let binaryWS = XLSX.utils.json_to_sheet(binary_univers);

    // Create a new Workbook
    var wb = XLSX.utils.book_new();

    // Name your sheet
    XLSX.utils.book_append_sheet(wb, binaryWS, "Binary values");

    // export your excel
    XLSX.writeFile(wb, "sample employee.xlsx");
  };

  addEmployeeModal = (value) => {
    this.setState({ showEmployeeModal: value });
    this.setState({ fileUploadError: "" });
  };

  closeUploadPreview = () => {
    this.setState({ showUploadPreview: false });
  }


  handleSearch = (event) => {
    event.preventDefault();
    let { value } = event.target;
    this.setState({ keyWord: value, offset: 0 });
    let data = {
      "keyWord": value,
      "pageNo": this.state.pageNo,
      "size": this.state.size
    }
    this.props.dispatch(dashboardActions.getInsightEmployeeList(data));
  }


  handleSizeChange = (e) => {
    this.setState({
      size: Number(e.target.value),
      pageNo: 1
    });
  };

  goPrev = () => {
    this.setState((prev) => ({
      pageNo: Math.max(prev.pageNo - 1, 1)
    }));
  };

  goNext = () => {
    const { getInsightEmployeeListTotal } = this.props.dashboard;
    const totalPages = Math.ceil(getInsightEmployeeListTotal / this.state.size);
    this.setState((prev) => ({
      pageNo: Math.min(prev.pageNo + 1, totalPages)
    }));
  };

  handleInputChange = (e) => {
    let { formData } = this.state;
    formData[e.target.name] = e.target.value;
    this.setState({ formData })
  }

  handleUpdateChange = (e) => {
    let { updateFormData } = this.state;
    updateFormData[e.target.name] = e.target.value;
    this.setState({ updateFormData })
  }

  addNewEmployee = () => {
    let { formData } = this.state;

    let saveRole = ""
    if (formData.role === "USER") {
      saveRole = "EMP"
    } else {
      saveRole = formData.role
    }
    let data = {
      "name": formData.name,
      "email": formData.email,
      "emp_id": formData.emp_id,
      "role": saveRole
    }
    let temp = { keyWord: "", pageNo: 1, size: 100 }
    this.props.dispatch(dashboardActions.createInsightEmployee(data, temp));
    this.setState({
      showEmployeeModal: false,
      formData: {
        "name": "",
        "email": "",
        "emp_id": "",
        "role": ""
      }
    })
  }

  updateNewEmployee = () => {
    let { updateFormData } = this.state;
    let data = {
      "id": updateFormData.id,
      "name": updateFormData.name,
      "email": updateFormData.email,
      "emp_id": updateFormData.emp_id
    }
    let temp = { keyWord: "", pageNo: 1, size: 100 }
    this.props.dispatch(dashboardActions.updateInsightEmployee(data, temp));
    this.setState({
      updateEmployeeDetails: false,
      updateFormData: {
        "id": "",
        "name": "",
        "email": "",
        "emp_id": ""
      }
    })
  }


  handleTabClick = (value) => { this.setState({ activeTab: value }) };

  onEdit = (value) => {
    let data = {
      "id": value.id,
      "name": value.name,
      "email": value.email,
      "emp_id": value.emp_id
    }
    this.setState({ updateEmployeeDetails: true, updateFormData: data })
  };

  closeUpdateEmployeeModal = () => {
    let data = {
      "id": "",
      "name": "",
      "email": "",
      "emp_id": ""
    }
    this.setState({ updateEmployeeDetails: false, updateFormData: data })
  }



  onDeleteConfirm = (data) => {
    this.setState({ showDeleteConfirm: true, updateFormData: { "id": data.id, "name": data.name } });
  }

  onCloseDeleteConfirm = () => {
    this.setState({ showDeleteConfirm: false });
  }

  finalDelete = () => {
    let { updateFormData } = this.state;
    let data = {
      "id": updateFormData.id
    }
    let temp = { keyWord: "", pageNo: 1, size: 100 }
    this.props.dispatch(dashboardActions.deleteInsightEmployee(data, temp));
    this.setState({ showDeleteConfirm: false, updateFormData: { "id": "", "name": "" } });
  }

  render() {
    const { dashboard } = this.props;
    const { saveInsightEmployeeListData, getInsightEmployeeListData = [], getInsightEmployeeListTotal, getEmployeeFieldsData } = dashboard;
    let { showDeleteConfirm, updateFormData, updateEmployeeDetails, activeTab, formData, loadedDataSheet, showEmployeeModal, showUploadPreview, pageNo, size } = this.state;
    console.log("updateFormData--->", updateFormData)
    const list = getInsightEmployeeListData && getInsightEmployeeListData.length > 0 ?
      getInsightEmployeeListData.map((ele, i) => ({
        sno: i + 1,
        id: ele.id,
        emp_id: ele.emp_id,
        name: ele.name,
        email: ele.email,
        role: ele.role === "EMP" ? "USER" : ele.role,
        createdAt: moment(ele.createdAt)
          .utcOffset("+05:30")
          .format("DD MMM, YYYY")
      })) : []

    const columns = [
      { label: "S.No", key: "sno" },
      { label: "Emp ID", key: "emp_id" },
      { label: "Name", key: "name" },
      { label: "Email", key: "email" },
      { label: "Role", key: "role" },
      { label: "Created At", key: "createdAt" },
    ];

    const start = getInsightEmployeeListTotal === 0 ? 0 : (pageNo - 1) * size + 1;
    const end = Math.min(pageNo * size, getInsightEmployeeListTotal);
    const totalPages = Math.ceil(getInsightEmployeeListTotal / size);


    const tabs = [
      {
        id: 1,
        label: "Add employee manually",
        description: "Select users to create new employee.",
        icon: <LuUsers size={25} />,
      },
      {
        id: 2,
        label: "Add employees with file upload",
        description: "Upload a file to add many employees.",
        icon: <LuUpload size={25} />,
      },
    ];

    return (
      <LayoutWrap>
        <div className="h-screen overflow-y-auto md:p-8 p-4 ">
          <div className="bg-white space-y-4 pb-24">

            {/* Header */}
            <div className="flex justify-between items-center">
              <h1 className="text-xl sm:text-2xl font-medium textblack">
                Employees
              </h1>
              <button onClick={() => this.addEmployeeModal(true)} className="flex items-center gap-2 bg-indigo-600 hover:bg-indigo-700 text-white px-4 py-2 font-medium rounded-md shadow-sm whitespace-nowrap">
                <FaPlus size={16} />
                <span>Upload Employee</span>
              </button>
              {/*                     
              <label className="cursor-pointer bg-indigo-600 text-white px-4 py-2 rounded-lg hover:bg-indigo-700">
                Upload File
                <input
                  type="file"
                  accept={SheetJSFT}
                  onChange={this.handleChange}
                  className="hidden"
                />
              </label> */}
            </div>

            {/* Error */}
            {this.state.fileUploadError && (
              <p className="text-red-500 text-sm">
                {this.state.fileUploadError}
              </p>
            )}



            {/* CARD */}
            <div className="border border-gray-300 rounded-lg overflow-hidden   bg-white ">
              {/* TOOLBAR */}
              <div className="p-3 md:p-4 border-b border-gray-100 flex flex-col md:flex-row md:items-center md:justify-between gap-4">
                {/* LEFT */}
                <div className="flex items-center gap-3">
                  <div className="flex items-center gap-2 text-sm textblack">
                    Show
                    <select
                      className="border border-gray-300 bg-white outline-none rounded-md px-2 py-1 font-semibold"
                      value={this.state.size} onChange={this.handleSizeChange}
                    >
                      <option value={10}>10</option>
                      <option value={20}>20</option>
                      <option value={50}>50</option>
                      <option value={100}>100</option>
                    </select>
                    Entries
                  </div>
                </div>

                {/* RIGHT */}
                <div className="flex flex-col sm:flex-row gap-3 w-full md:w-auto">

                  {/* SEARCH */}
                  <div className="relative w-full sm:w-64">
                    <LuSearch
                      className="absolute left-3 top-1/2 -translate-y-1/2 textblack"
                      size={16}
                    />
                    <input
                      type="text"
                      value={this.state.keyWord}
                      onChange={this.handleSearch}
                      placeholder="Search..."
                      className="w-full pl-9 pr-3 py-2 border border-gray-300 textblack placeholder:text-gray-800 rounded-md text-sm outline-none"

                    />
                  </div>

                  {/* PAGINATION */}
                  <div className="flex items-center gap-3 text-sm textblack">
                    <span>{start}-{end}  of {getInsightEmployeeListTotal}</span>
                    <div className="flex gap-1">
                      <button onClick={this.goPrev} disabled={this.state.pageNo === 1} className="p-1 border rounded">
                        <LuChevronLeft size={18} />
                      </button>
                      <button onClick={this.goNext} disabled={this.state.pageNo === totalPages} className="p-1 border rounded bg-purple-50 text-indigo-600">
                        <LuChevronRight size={18} />
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <Table
                list={list}
                columns={columns}
                onEdit={this.onEdit}
                onDelete={this.onDeleteConfirm}
              />
            </div>

          </div>

          {showEmployeeModal ? (
            <div className="fixed top-0 right-0 z-50 flex items-center justify-center w-full h-full bg-black bg-opacity-40 xl:h-screen">
              <div className="w-11/12 mx-auto bg-white rounded-lg shadow-sm xl:w-6/12 lg:w-9/12 ">
                {/* head */}
                <div className="flex items-center justify-between p-4 border-b md:px-8 ">
                  <h2 className="text-lg font-semibold md:text-xl test-gray-800 ">
                    Add Employees
                  </h2>
                  <div onClick={() => this.addEmployeeModal(false)} className="p-2 rounded-full cursor-pointer bg-slate-100 hover:bg-slate-200 ">
                    <MdOutlineClose size={22} className="textblack" />
                  </div>
                </div>

                <nav className="flex gap-6 md:px-8 px-4 mt-5" aria-label="Tabs">
                  {tabs.map((tab) => {
                    const isActive = activeTab === tab.id;

                    return (

                      <button
                        key={tab.id}
                        onClick={() => this.handleTabClick(tab.id)}
                        className={`flex items-center justify-between w-full max-w-md p-4 rounded-lg border transition-all duration-200 ${isActive
                          ? "border-indigo-500 bg-gradient-to-r from-indigo-100 to-white"
                          : "border-gray-300 bg-white hover:border-indigo-400"
                          }`}
                      >
                        <div className="flex items-center md:gap-3 gap-2">
                          <div className={`text-xl shrink-0 ${isActive ? "text-indigo-600" : "text-gray-500"}`}>{tab.icon}</div>
                          <div className="text-left">
                            <p className="text-sm font-semibold text-gray-800">{tab.label}</p>
                            <p className="text-xs text-gray-500">{tab.description}</p>
                          </div>
                        </div>
                        <div
                          className={`flex items-center justify-center w-6 h-6 p-0.5 rounded-full border ${isActive
                            ? "bg-indigo-600 border-indigo-600 text-white"
                            : "border-gray-400 text-transparent"
                            }`}
                        >
                          <LuCheck size={22} />
                        </div>
                      </button>
                    );
                  })}
                </nav>

                {activeTab === 1 ?
                  <>
                    <div className="space-y-4 md:px-8 px-4 py-6">
                      <div className="space-y-1">
                        <label className="block textblack text-sm font-medium">Enter Name</label>
                        <input
                          name="name"
                          placeholder="Enter Name"
                          value={formData.name || ""}
                          onChange={this.handleInputChange}
                          className="w-full border border-gray-300 rounded-lg px-3 py-2 outline-none transition-all"
                        />
                      </div>
                      <div className="space-y-1">
                        <label className="block textblack text-sm font-medium">Enter Email</label>
                        <input
                          name="email"
                          placeholder="Enter Email"
                          value={formData.email || ""}
                          onChange={this.handleInputChange}
                          className="w-full border border-gray-300 rounded-lg px-3 py-2 outline-none transition-all"
                        />
                      </div>
                      <div className="space-y-1">
                        <label className="block textblack text-sm font-medium">Enter Emp ID</label>
                        <input
                          name="emp_id"
                          placeholder="Enter Emp ID"
                          value={formData.emp_id || ""}
                          onChange={this.handleInputChange}
                          className="w-full border border-gray-300 rounded-lg px-3 py-2 outline-none transition-all"
                        />
                      </div>

                      <div className="space-y-1">
                        <label className="block textblack text-sm font-medium">
                          Enter Role
                        </label>

                        <select
                          name="role"
                          value={formData?.role || ""}
                          onChange={this.handleInputChange}
                          className="w-full border border-gray-300 rounded-lg px-3 py-2 outline-none transition-all bg-white"
                        >
                          <option value="">Select Role</option>
                          <option value="COACH">COACH</option>
                          <option value="USER">USER</option>
                        </select>
                      </div>


                      {/* Footer */}
                      <div className="flex justify-end gap-3 py-4 mt-2">
                        <div className="flex items-center justify-end gap-3">
                          <button onClick={() => this.addEmployeeModal(false)} className="px-6 py-2 text-base font-semibold text-gray-900 bg-white border border-gray-300 rounded-md active:scale-95 transition-all">Cancel</button>
                        </div>
                        <div className="flex items-center justify-end gap-3">
                          <button onClick={() => this.addNewEmployee()} className="px-6 py-2 text-base font-semibold text-white bg-indigo-600 rounded-md hover:bg-indigo-700 active:scale-95 transition-all">Create</button>
                        </div>
                      </div>
                    </div>
                  </>
                  : null}

                {activeTab === 2 ?
                  <>
                    <div className="m-4 space-y-8 md:m-8 h-[26rem] overflow-y-auto">
                      {/* data here */}
                      <div className="p-4 space-y-2 text-sm border divide-y rounded-md text-slate-800">
                        <h1 className="text-lg font-semibold text-slate-800 ">
                          {" "}
                          Guidelines for uploading the data
                        </h1>
                        <ol className="list-disc pl-6 space-y-1.5 py-4 text-slate-800 ">
                          <li className="">
                            {" "}
                            Mandatory Column include emp_id and email as first
                            column & second column should be in the file.
                          </li>
                          <li className="capitalize">
                            {" "}
                            Your file columns/headers should not contain any
                            special characters – this includes characters that
                            are not numbers or the English alphabet.
                          </li>
                          <li className="capitalize">
                            {" "}
                            Be careful not to include duplicates of the same
                            row – no two employees should have the same emp_id
                            or email.
                          </li>
                          <li className="capitalize">
                            {" "}
                            Date format must be same as DD-MM-YYYY
                          </li>
                          <li className="capitalize">
                            {" "}
                            See the sample data format for reference and
                            prepare your master data accordingly without any
                            change in mandatory column names
                          </li>
                          <li className="capitalize">
                            {" "}
                            Make sure your Excel sheet is not password
                            protected.
                          </li>
                        </ol>
                      </div>

                      <div className="space-y-4">
                        <div className="grid grid-cols-1 gap-4 xl:grid-cols-4 md:grid-cols-2">
                          {/* 1 */}
                          <div
                            onClick={() => this.downLoadSampleCSV()}
                            className="flex items-start p-2 px-4 space-x-4 rounded shadow-sm cursor-pointer 2xl:items-center bg-indigo-100 md:col-span-2"
                          >
                            <span class="material-symbols-outlined p-2 bg-white rounded-full text-indigo-600 shadow-sm">
                              download
                            </span>
                            <div>
                              <h1 className="text-sm font-medium md:text-base text-slate-800 ">
                                Download Sample Data
                              </h1>
                              <p className="text-sm text-gray-500">
                                See the sample data format for reference
                              </p>
                            </div>
                          </div>

                          {/* 2 */}
                          <input
                            type="file"
                            id="file"
                            accept={SheetJSFT}
                            onChange={this.handleChange}
                            hidden
                          />
                          <label
                            for="file"
                            className="rounded shadow-sm cursor-pointer bg-indigo-100 md:col-span-2"
                          >
                            <div className="flex items-start p-2 px-4 space-x-4 2xl:items-center ">
                              <span class="material-symbols-outlined p-2 bg-white rounded-full text-indigo-600 shadow-sm">
                                upload
                              </span>
                              <div>
                                <h1 className="text-sm font-medium md:text-base text-slate-800 ">
                                  Upload Master Data
                                </h1>
                                <p className="text-sm text-gray-500">
                                  Upload master data as per the guidelines
                                </p>
                              </div>
                            </div>
                          </label>
                        </div>

                        <div className="hidden">
                          <button
                            onClick={() => this.downLoadSampleCSV()}
                            className=" border border-green-500 rounded-md px-6 py-1.5 text-xs text-green-500 focus:outline-none"
                          >
                            Sample CSV
                          </button>

                          <button
                            onClick={this.handleFile}
                            className="ml-22 border border-indigo-500 rounded-md px-6 py-1.5 text-xs text-indigo-600 focus:outline-none"
                          >
                            Continue
                          </button>
                        </div>
                      </div>
                    </div>
                  </>
                  : null}

              </div>
            </div>
          ) : null}


          {updateEmployeeDetails ?
            <div className="fixed top-0 right-0 z-50 flex items-center justify-center w-full h-full bg-black bg-opacity-40 xl:h-screen">
              <div className="w-11/12 mx-auto bg-white rounded-lg shadow-sm xl:w-6/12 lg:w-9/12 ">
                {/* head */}
                <div className="flex items-center justify-between p-4 border-b md:px-8 ">
                  <h2 className="text-lg font-semibold md:text-xl test-gray-800 ">
                    Update Employees
                  </h2>

                  <div
                    onClick={() => this.closeUpdateEmployeeModal(false)}
                    className="p-2 rounded-full cursor-pointer bg-slate-100 hover:bg-slate-200 "
                  >
                    <svg
                      className="w-6 h-6 fill-current"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                    >
                      <path d="M16.192 6.344L11.949 10.586 7.707 6.344 6.293 7.758 10.535 12 6.293 16.242 7.707 17.656 11.949 13.414 16.192 17.656 17.606 16.242 13.364 12 17.606 7.758z"></path>
                    </svg>
                  </div>
                </div>

                <div className="space-y-4 md:px-8 px-4 py-6">
                  <div className="space-y-1">
                    <label className="block textblack text-sm font-medium">Enter Name</label>
                    <input
                      name="name"
                      placeholder="Enter Name"
                      value={updateFormData.name || ""}
                      onChange={this.handleUpdateChange}
                      className="w-full border border-gray-300 rounded-lg px-3 py-2 outline-none transition-all"
                    />
                  </div>
                  <div className="space-y-1">
                    <label className="block textblack text-sm font-medium">Enter Email</label>
                    <input
                      name="email"
                      placeholder="Enter Email"
                      value={updateFormData.email || ""}
                      onChange={this.handleUpdateChange}
                      className="w-full border border-gray-300 rounded-lg px-3 py-2 outline-none transition-all"
                    />
                  </div>
                  <div className="space-y-1">
                    <label className="block textblack text-sm font-medium">Enter Emp ID</label>
                    <input
                      name="emp_id"
                      placeholder="Enter Emp ID"
                      value={updateFormData.emp_id || ""}
                      onChange={this.handleUpdateChange}
                      className="w-full border border-gray-300 rounded-lg px-3 py-2 outline-none transition-all"
                    />
                  </div>

                  {/* Footer */}
                  <div className="flex justify-end gap-3 py-4 mt-2">
                    <div className="flex items-center justify-end gap-3">
                      <button onClick={() => this.updateNewEmployee()} className="px-6 py-2 text-base font-semibold text-white bg-indigo-600 rounded-md hover:bg-indigo-700 active:scale-95 transition-all">Update</button>
                    </div>
                  </div>
                </div>

              </div>   </div>
            : null}



          {/* Upload Preview */}
          {/* {this.state.showUploadPreview && (
            <UploadPreview
              loadedDataSheet={this.state.loadedDataSheet}
              saveUploadEmployee={this.saveUploadEmployee}
            />
          )} */}


          {showUploadPreview ? (
            <>
              <UploadPreview
                loadedDataSheet={this.state.loadedDataSheet}
                closeUploadPreview={this.closeUploadPreview}
                saveUploadEmployee={this.saveUploadEmployee}
                handleChange={this.handleChange}
                SheetJSFT={SheetJSFT}
                saveInsightEmployeeListData={saveInsightEmployeeListData}
                selectOnboardingDateField={this.selectOnboardingDateField}
                selectFieldType={this.selectFieldType}
                crrFieldType={[]}
                getEmployeeFieldsData={getEmployeeFieldsData}
              />
            </>
          ) : null}


          {showDeleteConfirm ?
            <>
              <DeleteEmpModal
                finalDelete={this.finalDelete}
                onClose={this.onCloseDeleteConfirm}
                empName={updateFormData && updateFormData.name ? updateFormData.name : ""}
              />
            </>
            : null}



        </div>
      </LayoutWrap>
    );
  }
}

const mapStateToProps = (state) => {
  const { dashboard } = state;
  return { dashboard };
};

export default connect(mapStateToProps)(Employees);